import './index.scss'

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="site-footer__content">
        <p className="site-footer__title">Contact</p>
        <div className="site-footer__links">
          <a href="mailto:christianturner528@gmail.com">Email</a>
          <a href="https://www.linkedin.com/in/christian-turner-jones-785390319/" target="_blank" rel="noreferrer">LinkedIn</a>
          <a href="https://github.com/cxt338" target="_blank" rel="noreferrer">GitHub</a>
        </div>
      </div>
    </footer>
  )
}

export default Footer
